import { getMealPlans } from "@/utils/apis/plan-service";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { usePlansStore } from "@/utils/stores/usePlansStore";
import { useCallback, useEffect, useState } from "react";

export const useGetMealPlans = () => {
    const { auth } = useAuthStore();
    const { updatePlans, plans } = usePlansStore();
    const [isLoading, setIsLoading] = useState(false);

    const fetchMealPlan = useCallback(async () => {
        const { idToken, userId } = auth;

        if (!idToken || !userId) return;

        try {
            setIsLoading(true);
            const mealPlans = await getMealPlans(userId, idToken);
            updatePlans({ mealPlans });
        } catch (error) {
            updatePlans({ mealPlans: null });

            if (error instanceof Error) {
                if (error.message.includes("Session expired")) {
                    throw new Error("Session expired");
                } else if (error.message.includes("Nessun meal plan trovato")) {
                    throw new Error(error.message);
                }
            }

            throw new Error("Unexpected error on get meal plans");

        } finally {
            setIsLoading(false);
        }
    }, [auth, updatePlans]);

    useEffect(() => {
        fetchMealPlan();
    }, [fetchMealPlan]);

    return {
        mealPlans: plans?.mealPlans ?? null,
        isLoading,
        refetch: fetchMealPlan,
    }
}